/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-08-14 14:58:08
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-08-15 13:53:20
 * @FilePath: \toolmap\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import typhoon from '../views/typhoon.vue'
import wind from '../views/wind.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'typhoon',
    component: typhoon
  },
  {
    path: '/wind',
    name: 'wind',
    component: wind
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
